import React, { useEffect } from 'react' 

import Dashboard from 'controllers/Dashboard';
import ProfileEditController from 'controllers/profile/Edit';
import CompanyOverviewController from 'controllers/company/Overview';

import OverviewController from 'controllers/product/Overview';

import ProductReservationOverviewController from 'controllers/productreservation/Overview';
import MyProductReservationOverviewController from 'controllers/myproductreservation/Overview';

import CompanyAddController from 'controllers/company/Add';

import ProductAddController from 'controllers/product/Add';
import CompanyUserOverviewController from 'controllers/companyuser/Overview';
import CompanyUserAddController from 'controllers/companyuser/Add';

import Login from 'controllers/auth/Login';
import SignIn from 'controllers/auth/SignIn';
import ResetPassword from 'controllers/auth/ResetPassword';
import ResetPasswordVerify from 'controllers/auth/ResetPasswordVerify';
import Logout from 'controllers/auth/Logout';
import AccountVerify from 'controllers/auth/AccountVerify';


import { useLocation } from 'react-router-dom'
import store from 'redux/store';
import messageSlice from 'redux/messageSlice';
export default function Root({...data}) { 
   const location = useLocation()

//	if(!store.getState().chat.isConnected) {
//		store.dispatch(messageSlice.actions.startConnecting());
//	}
		
   useEffect(() => {
		if(!store.getState().chat.isConnected) {
			store.dispatch(messageSlice.actions.startConnecting({content: location.pathname}));
		} else { 	
			store.dispatch(messageSlice.actions.submitMessage({content: location.pathname}));
		}
	
         
   },[location]) 

	switch(data.view) {
		case 'dashboard':
			return <Dashboard /> 
		case 'profile':
			return <ProfileEditController />
		case 'companyoverview':
			return <CompanyOverviewController />
		case 'product-overview':
			return <OverviewController />
		case 'product-reservation-overview':
			return <ProductReservationOverviewController />
		case 'my-reservations':
			return <MyProductReservationOverviewController />
		case 'company-add':
			return <CompanyAddController />
		case 'product-add':
			return <ProductAddController />
		case 'company-user-overview':
			return <CompanyUserOverviewController />
		case 'company-user-add':
			return <CompanyUserAddController />
		case 'login':
			return <Login />
		case 'signin':
			return <SignIn />
		case 'reset-password':
			return <ResetPassword />
		case 'reset-password-verify':
			return <ResetPasswordVerify />
		case 'logout':
			return <Logout />
		case 'account-verify':
			return <AccountVerify />
		default:
			return <Dashboard />
		
	}
}